import { userSelectors, userActions } from '../redux/userSlice'
import { fetchHelper } from './api'
import { fetchCompanyLogo } from './authApi'

export const getUserProfile = () => async (dispatch, getState) => {
    const state = getState()
    const { email } = userSelectors.userDetails(state)

    try {
        const response = await fetchHelper.get(`/Customer/${email}`)
        dispatch(userActions.updateDetails({ userDetails: response.data }))
        return true
    } catch (error) {
        if (process.env.NODE_ENV !== 'production')
            console.warn(
                'Failed to fetch user profile, resetting auth state',
                error
            )
        dispatch(userActions.logout())
        return false
    }
}

export const getCompanyLogo = () => async (dispatch, getState) => {
    const state = getState()
    const { email } = userSelectors.userDetails(state)

    try {
        const logo = await fetchCompanyLogo(email)

        dispatch(
            userActions.updateDetails({
                logo,
            })
        )
    } catch (error) {
        if (process.env.NODE_ENV !== 'production')
            console.warn(
                'Failed to fetch company logo, using the great empty string.',
                error
            )
        dispatch(
            userActions.updateDetails({
                logo: '',
            })
        )
    }
}
